import { defineStore } from 'pinia'
import { login, getMenu } from '../api/request'
import { ElMessage } from 'element-plus'
import Cookies from 'js-cookie'

export const useUserStore = defineStore('user', {
    state: () => ({
        token: localStorage.getItem('ai_employee_token') || '',
        userInfo: JSON.parse(localStorage.getItem('ai_employee_userInfo')) || {},
        menuList: [], // 树形菜单列表
        dynamicRoutes: []
    }),
    /*actions: {
        // 登录
        async loginAction(userForm) {
            const res = await login(userForm)
            if (res.code === 200) {
                this.token = res.object.access_token
                this.userInfo = res.data.user_info
                // 存储token和用户信息
                localStorage.setItem('ai_employee_token', this.token)
                localStorage.setItem('ai_employee_userInfo', JSON.stringify(this.userInfo))
                ElMessage.success(res.message)
                return true
            } else {
                ElMessage.error(res.message)
                return false
            }
        },
        // 获取树形菜单
        async getMenuAction() {
            const res = await getMenu(this.token)
            if (res.code === 200) {
                this.menuList = res.data
            } else {
                ElMessage.error(res.msg)
            }
        },
        // 退出登录
        logoutAction() {
            this.token = ''
            this.userInfo = {}
            this.menuList = []
            localStorage.clear()
            ElMessage.success('退出成功')
        }
    }*/
})